import styled, { css, keyframes } from 'styled-components'
import IconArrowRight from '../../assets/img/icon-arrow-right.svg'

const showFilter = keyframes`
  from {
    transform: translate3d(100%, 0px, 0px);
  } to {
    transform: translate3d(0px, 0px, 0px);
  }
`

const showFilterClose = keyframes`
  from {
    opacity: 0;
    transform: translate3d(600px, 0px, 0px);
  } to {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
  }
`

const showModal = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const Modal = styled.nav`
  ${({ active }) => css`
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    width: 100%;
    height: 100vh;
    display: block;
    transition: all 1s;
    z-index: 900;
    cursor: auto;
    animation: ${showModal} 400ms;

    @media (min-width: 1171px) {
      display: none;
    }
  `}
`

export const FilterMobileContent = styled.div`
  width: 300px;
  height: 100vh;
  position: absolute;
  right: 0;
  z-index: 901;

  @media (max-width: 500px) {
    width: 70%;
  }
`

export const CloseModal = styled.div`
  background: #a71e26;
  padding: 10px;
  border: 0;
  position: absolute;
  left: -40px;
  cursor: pointer;
  animation: ${showFilterClose} 400ms;

  img {
    filter: brightness(250%);
    width: 20px;
    height: 20px;
  }
`

export const FilterMobileBox = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    height: 100%;
    cursor: auto;
    animation: ${showFilter} 400ms;
  `}
`

export const FilterMobileHeader = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.primary};
    color: ${theme.colors.white}
    border-top: 1px solid #bbbbbb;
    font-weight: bold;
    font-size: 18px;
    padding: 20px 20px;
  `}

  color: #fff;
`

export const Wrapper = styled.div`
  padding: 30px 20px;
  max-height: 84vh;
  background-color: white;
`
